import { Config } from './types'

/** Promise that resolves when the initial auth state has been determined. */
let resolveAuthInitialized: () => void
export const authInitialized = new Promise<void>((resolve) => {
	resolveAuthInitialized = resolve
})
export function notifyAuthInitialized() {
	resolveAuthInitialized()
}

/** The authentication module config, with default values.
 * Use the setConfig method to update the config.
 */
let config: Config = {
	clientId: '',
	clientSecret: '',
}

/** Prepare the API configuration for authentication. */
export function prepareConfigurationForAuth(configuration: unknown) {
	// configuration.accessToken = (name: string, scopes?: string[]): string => {
	// 	return ''
	// }
}

export function getAuthConfig(): Config {
	return config
}

export function setAuthConfig(newConfig: Config) {
	config = newConfig
}
